import type { RegisterInput } from "@academichub/shared";
import { api, loadCsrfToken, setCsrfToken } from "./client";
import type { RegisterOptions, RegisterResult, SessionResponse } from "./types";

/** Endpoint autentikasi. Token CSRF ikut disimpan setelah login/me. */

function rememberCsrf(session: SessionResponse): SessionResponse {
  setCsrfToken(session.csrfToken);
  return session;
}

export async function fetchMe(): Promise<SessionResponse> {
  try {
    return rememberCsrf(await api.get<SessionResponse>("/auth/me"));
  } catch {
    // Belum masuk: ambil token CSRF anonim agar form login bisa dikirim.
    await loadCsrfToken();
    throw new Error("Belum masuk");
  }
}

export async function login(payload: {
  username: string;
  password: string;
}): Promise<SessionResponse> {
  const session = await api.post<SessionResponse>("/auth/login", payload);
  return rememberCsrf(session);
}

export async function logout(): Promise<{ message: string }> {
  const result = await api.post<{ message: string }>("/auth/logout");
  setCsrfToken(null);
  return result;
}

export async function changePassword(payload: {
  currentPassword: string;
  newPassword: string;
}): Promise<{ message: string }> {
  return api.post<{ message: string }>("/auth/change-password", payload);
}

/** Pilihan peran/fakultas/program studi/unit untuk formulir pendaftaran publik. */
export function registerOptions(): Promise<RegisterOptions> {
  return api.get<RegisterOptions>("/auth/register/options");
}

/**
 * Kirim pendaftaran mandiri. Akun berstatus PENDING sampai disetujui admin
 * program studi, jadi TIDAK ada sesi yang dibuat di sini.
 */
export function register(payload: RegisterInput): Promise<RegisterResult> {
  return api.post<RegisterResult>("/auth/register", payload);
}
